import contractorsState from './contractors/state'

export default {
    ...contractorsState,

    order: {},
    types: [],
    paymentTypes: [],
    brands: [],
    discounts: [],
    restaurants: [],
    sectors: [],
    regions: [],
    initCoordinates: {},
    statuses: [],
    modalShow: false,
    mode: { name: '', variant: 'primary', message: '' },
    dirtiesAttributes: [],
    dirtyDishes: [],
    resultServer: null,
    waitSaving: false,
    permissions: {
        write: [],
        read: [],
    },
    stopList: [],
    restaurantComment: null,
    guest_calling: null,
    notifications: null,
    isChangeDish: false,
    limitationPeriods: [],
    availabilities: [],
    addressAvailable: false,
    deliveryIntervals: [],
    reasonChangeTime: null,
    reasonChanges: null,
    resendDishes: null,
    hasResendDishes: false,
    minSumOrder: 0,
    deliveryIntervalsV2: [],

    // Ожидаемые даты доставки
    predictedDeliveryDate: null,
    predictedTime: 0,
    predictedDeliveryIntervals: [],

    // ui
    updateDate: false,
    isNoteExcessive: false,
    isMainTransactionInvalid: false,

    isIntervalsAvailable: false,
    originalOrderFirstPaymentType: {},
    originalCompletedPayments: [],

    // Будет хранить полный, "сырой" ответ от /intervals API
    deliveryAvailabilityData: null,

    isAdditionalTransactionInvalid: false,
}
